module.exports = __webpack_public_path__ + "static/organicdandelionmain-4ec7eb8e562a849fcaf811d1be52d854.png";